// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { CatalogFeed } from './catalog-feed';
import { ManufacturerFeedStatus } from './manufacturer-feed-status';
import { ManufacturerImage } from './manufacturer-image';
import { ProductType } from './product-type';
import { Supplier } from './supplier';
import { ActiveStatusEnum } from './enums';
import { CatalogFeedEnum } from './enums';
import { ManufacturerFeedStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Manufacturer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getStatusParents() {
    return [this.supplier];
  }

  getStatusId() {
    return this.activeStatusId;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(200) */
  apiLink?: string;
  /** Enum FK catalogFeed */
  catalogFeedId?: CatalogFeedEnum;
  /** String(50) */
  catalogFeedKey?: string;
  /** Enum FK manufacturerFeedStatus */
  manufacturerFeedStatusId!: ManufacturerFeedStatusEnum;
  /** String(60) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId!: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK catalogFeedId */
  catalogFeed!: CatalogFeed;
  /** FK manufacturerFeedStatusId */
  manufacturerFeedStatus!: ManufacturerFeedStatus;
  /** Inv FK manufacturerId */
  manufacturerImages!: ManufacturerImage[];
  /** Inv FK manufacturerId */
  productTypes!: ProductType[];
  /** FK supplierId */
  supplier!: Supplier;
}

